import PoliceDepartment from '../enums/policeDepartment';

const policeDepartmentTranslation: { [key: number]: string } = {
  [PoliceDepartment.AutomovileCenter]: 'Centro del automovilista',
  [PoliceDepartment.Digesset]: 'Digesset',
  [PoliceDepartment.DriverHouse]: 'Casa del conductor',
};

export default policeDepartmentTranslation;
